(function () {
  // ---- Settings
  const START_DELAY_MS = 400;   // initial delay before first run
  const RECHECK_MS     = 300;   // retry interval while Junip loads
  const MAX_TRIES      = 30;    // retries before relying on observer

  const COUNT_SELECTOR = '.junip-product-summary-review-count';
  const FLAG_ATTR      = 'data-junip-count-formatted';

  function formatCounts(root = document) {
    const els = root.querySelectorAll(COUNT_SELECTOR);
    if (!els.length) return false;

    els.forEach((el) => {
      // If Junip re-renders, it's a new node, so this runs again (good)
      if (el.getAttribute(FLAG_ATTR) === '1') return;

      const raw = (el.textContent || '').trim();  // e.g. "(5)" or "( 5 )"
      const count = parseInt(raw.replace(/\D/g, ''), 10);
      if (Number.isNaN(count)) return;

      const word = count === 1 ? 'review' : 'reviews';

      // Write it INSIDE the parentheses exactly as requested
      el.textContent = `(${count} ${word})`;

      el.setAttribute(FLAG_ATTR, '1');
    });

    return true;
  }

  function startObserver() {
    const target = document.body;
    if (!target) return;

    const observer = new MutationObserver(() => {
      // Re-apply whenever Junip updates/rehydrates
      formatCounts(document);
    });

    observer.observe(target, { childList: true, subtree: true });
  }

  // Start after initial delay
  setTimeout(() => {
    let tries = 0;

    const tick = () => {
      tries++;
      formatCounts(document);

      if (tries < MAX_TRIES) {
        setTimeout(tick, RECHECK_MS);
      }
    };

    tick();
    startObserver();
  }, START_DELAY_MS);
})();

// Shop Pay reads the first selling_plan control, not the checked radio.
// Appstle renders the subscription radio first, so Buy with Shop stays on
// the subscription after One Time Purchase is selected. This hidden input
// stays first and mirrors the selected plan (empty for one-time).
(function () {
  var SYNC_SELECTOR = 'input[data-selling-plan-sync]';

  function planValue(form) {
    var checked = form.querySelector('input[type="radio"][name="selling_plan"]:checked:not([data-selling-plan-sync])');
    if (checked) return checked.value || '';

    var field = form.querySelector('select[name="selling_plan"], input[name="selling_plan"]:not([type="radio"]):not([data-selling-plan-sync])');
    if (field) return field.value || '';

    return '';
  }

  function syncForm(form) {
    if (!form || form.classList.contains('installment')) return;
    if (!form.querySelector('.appstle_stand_alone_selector, input[name="selling_plan"], select[name="selling_plan"]')) return;

    var sync = form.querySelector(SYNC_SELECTOR);
    if (!sync) {
      sync = document.createElement('input');
      sync.type = 'hidden';
      sync.setAttribute('data-selling-plan-sync', '');
      sync.name = 'selling_plan';
      sync.value = '';
    }

    if (form.firstElementChild !== sync) form.prepend(sync);

    var value = planValue(form);
    if (sync.value !== value) sync.value = value;
    if (sync.name !== 'selling_plan') sync.name = 'selling_plan';
  }

  function syncAll() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(syncForm);
  }

  var queued = false;
  function queueSync() {
    if (queued) return;
    queued = true;
    setTimeout(function () {
      queued = false;
      syncAll();
    }, 0);
  }

  document.addEventListener('change', function (event) {
    if (event.target && event.target.closest && event.target.closest('form[action*="/cart/add"]')) queueSync();
  });

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    if (target.closest('input[name="selling_plan"], select[name="selling_plan"], .appstle_stand_alone_selector')) return;
    var form = target.closest('form[action*="/cart/add"]');
    if (form) syncForm(form);
  }, true);

  function start() {
    syncAll();
    new MutationObserver(queueSync).observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['value', 'checked']
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();